export default "__VITE_ASSET__BnVAEJE___"